module.exports = __webpack_public_path__ + "img/foto aire libre.cd053c23.jpg";